import React from 'react';
import Button from '@mui/material/Button';

import { ReplaceIcon, UploadIcon } from './actionIcons';

// CP-5556: the dashboard's one Upload image / Replace image control (Martina's spec). Outlined blue, always
// "image" (never "picture" or "photo"): [UPLOAD IMAGE] while there is no image, [REPLACE IMAGE] once there is.
// `overImage` sits it on top of the photo: white fill that turns hollow on hover, as on Edit Bus.
// To open a file picker either pass onClick (a dropzone's open) or component="label" with a hidden
// <input type="file"> as children. Delete sits beside it as DeleteIconButton / DeleteButton (CP-5545).
const OVER_IMAGE_SX = { bgcolor: '#fff', '&:hover': { bgcolor: 'transparent' }, '&.Mui-disabled': { bgcolor: 'rgba(255,255,255,0.6)' } };

/** @type {React.ForwardRefExoticComponent<Record<string, any> & React.RefAttributes<HTMLButtonElement>>} */
const ImageActionButton = React.forwardRef(function ImageActionButton(
    { hasImage = false, overImage = false, label, disabled = false, sx, children, ...rest },
    ref,
) {
    const Icon = hasImage ? ReplaceIcon : UploadIcon;
    const text = label || (hasImage ? 'Replace image' : 'Upload image');
    const sxList = [overImage && OVER_IMAGE_SX, ...(Array.isArray(sx) ? sx : [sx])];
    return (
        <Button ref={ref} {...rest} sx={sxList} variant="outlined" color="primary" startIcon={<Icon />} disabled={disabled}>
            {text}
            {children}
        </Button>
    );
});

export default ImageActionButton;
